<template>
    <div>
        <form :action="action" :method="method" :target="target" :class="cssClass">
            <input v-if="defaultFilter && defaultFilter.search" type="hidden" name="search[value]" :value="defaultFilter.search" />
            <template v-for="filter in filters">
                <template v-if="filter.type.includes('float[]')">
                    <input type="hidden" v-if="Array.isArray(filter.value)"
                           :name="filter.name + '[]'"
                           :value="v" v-for="v in filter.value"
                    >
                </template>
                <template v-else-if="filter.type.includes('[]')">
                    <input type="hidden" v-if="Array.isArray(filter.value)"
                        :name="filter.name + '[]'"
                        :value="v.id" v-for="v in filter.value"
                    >
                    <input type="hidden" v-if="filter.value && filter.value.id"
                        :name="filter.name + '[]'"
                        :value="filter.value.id"
                    >
                </template>
                <template v-else>
                    <template v-if="filter.type.includes('daterange')">
                        <template v-if="filter.value && (null !== filter.value.startDate && null !== filter.value.endDate)">
                            <input type="hidden"
                               :name="filter.name + '[startDate]'"
                               :value="filter.value.startDate"
                            >
                            <input type="hidden"
                               :name="filter.name + '[endDate]'"
                               :value="filter.value.endDate"
                            >
                        </template>
                    </template>
                    <input type="hidden" v-else-if="filter.type.includes('range')"
                        :name="filter.name + '[]'"
                        :value="v" v-for="v in filter.value"
                    >
                    <template v-else-if="!filter.type.includes('[]') && !filter.type.includes('range')">
                        <input type="hidden" v-if="filter.value"
                            :name="filter.name"
                            :value="filter.value"
                        >
                    </template>
                </template>
            </template>
            <input v-if="extraData" type="hidden" :name="extraData.name"
               :value="v" v-for="v in extraData.values"
            />
            <button type="submit" v-if="active" class="btn btn-confirm btn-sm fix">{{ t(buttonName) }}</button>
        </form>
    </div>
</template>

<script>
    import Template from "../pages/ProductAttribute/template";
    export default {
        components: {Template},
        props: {
            active: {
                type: Boolean,
                default: true
            },
            action: {
                type: String,
                required: true
            },
            buttonName: {
                type: String,
                default: 'Export'
            },
            method: {
                type: String,
                default: 'GET'
            },
            target: {
                type: String,
                default: '_blank'
            },
            cssClass: {
                type: String,
                default: 'pull-left'
            },
            filters: {
                type: Array,
                required: true,
            },
            extraData: {
                type: Object,
                default: function() {
                    return {
                        name: null,
                        values: []
                    };
                }
            },
            defaultFilter: {
                type: Object,
                required: false
            }
        },
        mounted() {
        },
        data()
        {
            return {};
        }
    }
</script>

<style>
    .fix {
        margin-top: 5px;
    }
</style>


// WEBPACK FOOTER //
// FormExport.vue?71817fb4